/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BriefResourceClient
 */
export interface BriefResourceClient {
    /**
     * 
     * @type {string}
     * @memberof BriefResourceClient
     */
    identityId?: string;
    /**
     * 
     * @type {string}
     * @memberof BriefResourceClient
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof BriefResourceClient
     */
    organizationId?: string;
    /**
     * 
     * @type {string}
     * @memberof BriefResourceClient
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof BriefResourceClient
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof BriefResourceClient
     */
    companyName?: string;
    /**
     * 
     * @type {string}
     * @memberof BriefResourceClient
     */
    pictureUrl?: string;
}

/**
 * Check if a given object implements the BriefResourceClient interface.
 */
export function instanceOfBriefResourceClient(value: object): value is BriefResourceClient {
    return true;
}

export function BriefResourceClientFromJSON(json: any): BriefResourceClient {
    return BriefResourceClientFromJSONTyped(json, false);
}

export function BriefResourceClientFromJSONTyped(json: any, ignoreDiscriminator: boolean): BriefResourceClient {
    if (json == null) {
        return json;
    }
    return {
        
        'identityId': json['identityId'] == null ? undefined : json['identityId'],
        'companyId': json['companyId'] == null ? undefined : json['companyId'],
        'organizationId': json['organizationId'] == null ? undefined : json['organizationId'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'companyName': json['companyName'] == null ? undefined : json['companyName'],
        'pictureUrl': json['pictureUrl'] == null ? undefined : json['pictureUrl'],
    };
}

export function BriefResourceClientToJSON(value?: BriefResourceClient | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'identityId': value['identityId'],
        'companyId': value['companyId'],
        'organizationId': value['organizationId'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'companyName': value['companyName'],
        'pictureUrl': value['pictureUrl'],
    };
}

